export const LoginLoc = {
    pageTitle: {
        ru: 'Вход в аккаунт',
        en: 'Account Login',
    },
    recoveryPageTitle: {
        ru: 'Активация/Восстановление',
        en: 'Activation/Recovery',
    },
    recoveryFormTitle: {
        ru: 'Введите телефон, который вы использовали для входа.',
        en: 'Enter the phone that you used to log in.',
    },
    loginPlaceholder: {
        ru: 'Введите номер телефона',
        en: 'Enter phone number',
    },
    passwordPlaceholder: {
        ru: 'Пароль',
        en: 'Password',
    },
    confirmPassword: {
        ru: 'Подтвеждение пароля',
        en: 'Confirm password',
    },
    recoveryButton: {
        ru: 'Восстановить/Активировать',
        en: 'Recovery/Activate',
    },
    generalLogin: {
        ru: 'Главная авторизации',
        en: 'Home authorization',
    },
    forgotPassword: {
        ru: 'Забыли пароль?',
        en: 'Forgot your password?',
    },
    dontHaveAccount: {
        ru: 'Еще нет аккаунта?',
        en: "Don't have an account yet?",
    },
    register: {
        ru: 'Зарегистрироваться',
        en: 'Sign up',
    },
    signIn: {
        ru: 'Войти',
        en: 'Sign In',
    },
    send: {
        ru: 'Отправить',
        en: 'Send',
    },
    invalidToken: {
        ru: '<h3>Неверный токен</h3> Время валидности токена закончилось, либо такого токена не существует.',
        en: '<h3>Invalid token</h3> The token validity time has expired, or such a token does not exist.',
    },
    invalidCode: {
        ru: 'Неверный код',
        en: 'Invalid code',
    },
    unequalPasswords: {
        ru: 'Пароли не равны',
        en: 'Unequal passwords',
    },
    resetCode: {
        ru: 'Не получили код? Повторно код можно отправить через {timer} секунд.',
        en: "Didn't get the code? The code can be resubmitted after {timer} seconds.",
    },
    resendCode: {
        ru: 'Отправить код еще раз',
        en: 'Resend code',
    },
    advantages: {
        quickOrder: {
            title: {
                ru: 'БЫСТРОЕ ОФОРМЛЕНИЕ ЗАКАЗА',
                en: 'QUICK ORDER',
            },
            detail: {
                ru: 'Самостоятельно оформляйте заказы в личном кабинете, контролируйте время аренды и документооборот',
                en: 'Make orders on your own in your account, control the time of rent and workflow',
            },
        },
        personalBonus: {
            title: {
                ru: 'ПЕРСОНАЛЬНЫЕ БОНУСЫ И СКИДКИ',
                en: 'PERSONAL BONUSES AND DISCOUNTS',
            },
            detail: {
                ru: 'Получайте персональные бонусы и скидки, накапливайте баллы, которое можно потратить на разные услуги',
                en: 'Get personal bonuses and discounts, accumulate points that can be spent on various services',
            },
        },
        orderHistory: {
            title: {
                ru: 'ИСТОРИЯ ВСЕХ ВАШИХ ЗАКАЗОВ',
                en: 'HISTORY OF ALL YOUR ORDERS',
            },
            detail: {
                ru: 'Ваши данные всегда под рукой. Уточнить детали или повторить прошлый заказ можно в два клика',
                en: 'Your data is always at hand. You can specify details or repeat the previous order in two clicks',
            },
        },
    },
    recoveryPhoneCodeMessage: {
        ru: 'На ваш номер телефона {phone} отправлено SMS с кодом активации аккаунта. Введите, пожалуйсте его в это поле.',
        en: 'An SMS with an account activation code has been sent to your phone number {phone}. Please enter it in this field.',
    },
};
